import * as types from '../action/actionTypes';
import initialState from './initialState';


export default class TenantMeterReducer {
  static MeterReducer(state = initialState.MeterValue, action) {
        switch (action.type) {
            case types.GET_DATALOG_VALUE_SUCCESSFULL: return {
                MeterValueList: action.getResponse,
            };    
            default : return state; 
        }   
    }

}
